import { useEffect, useRef, useState } from 'react'

export const useDebouncedValue = <T = unknown>(value: T, waitMs: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const mountedRef = useRef(false)
  const cooldownRef = useRef(false)
  const timeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    mountedRef.current = true

    return () => clearTimeout(timeoutRef.current)
  }, [])

  useEffect(() => {
    if (!mountedRef.current) {
      return
    }

    clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      cooldownRef.current = false

      setDebouncedValue(value)
    }, waitMs)
  }, [value, waitMs])

  return debouncedValue
}
